import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cfs: [],
};
const cfsSlice = createSlice({
  name: "cfs",
  initialState,
  reducers: {
    setCfs: (state, action) => {
      state.cfs = action.payload;
    },
  },
});
export const { setCfs } = cfsSlice.actions;
export default cfsSlice.reducer;
